import {useMetaTagJsonContent} from './useMetaTagJsonContent';

let examinationMarkings = null;

function getExaminationMarkings()
{
    if (examinationMarkings === null) {
        examinationMarkings = useMetaTagJsonContent('examinationMarkings');
    }
    return examinationMarkings;
}

export const comparisonMethods = {
    isXODanger: async (examination) => {
        return examination?.danger?.fire || examination?.danger?.person;
    },
    isFreeText: async (examination, options) => {
        // TODO: freeText Variables
        const getTemplate = (number) => options.examinationTemplates.filter(examination => examination.number === number)[0];
        return examination.number === undefined
            || getTemplate(examination.number) === undefined
            || (
                examination?.deficiency.text !== getTemplate(examination.number).description
                || examination?.danger.person !== getTemplate(examination.number).personDanger
                || examination?.danger.fire !== getTemplate(examination.number).fireDanger
            );
    },
    isImage: async (examination) => {
        return examination?.images?.length > 0;
    },
    isThermal: async (examination) => {
        return examination.thermal;
    },
    isDocumentation: async (examination) => {
        return examination.documentation;
    },
    isMaintenance: async (examination) => {
        return examination.maintenance;
    },
    isDirty: async (examination) => {
        return examination.dirty;
    },
};

export async function examinationMarks(examination, highlightSettings, comparisonMethodOptions)
{
    let classObject = {};
    for (const [id, marking] of Object.entries(getExaminationMarkings().value)) {
        classObject[marking.className] = highlightSettings[id] && await comparisonMethods[marking.compareMethod](examination, comparisonMethodOptions);
    }
    return classObject;
}

export function examinationIcons(examination, comparisonMethodOptions)
{
    return Object.values(getExaminationMarkings().value)
        .map(async marking => await comparisonMethods[marking.compareMethod](examination, comparisonMethodOptions) ? marking.icon : '');
}
